import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Loader } from '../../../../../components/Loader';
import { selectWorks } from '../../../../Api/selectors';
import { createVehicleWithProps } from '../../../actions';
import { REQUEST_VEHICLE } from '../../../constants';
import { VehicleCreateField } from './Fields';
import { render } from 'react-dom';
import cn from 'classnames';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import styles from './FifthStep.module.css';

const Container = styled.div`
  width: 100%;

  .cols {
  }
  .col {
    min-width: 400px;
    padding-right: 48px;

    @media (max-width: 768px) {
      padding-right: 0;
      min-width: 300px;
      width: 100%;
    }
  }

  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }
`;

const STATE = {};

class VehicleCreateStep5Comp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  save() {
    this.props.onSave();
  }

  prevStep() {
    this.props.getPrevStep();
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container className={styles.container}>
        <VBox className={cn('cols', styles.containerCol)}>
          <div className={cn('container-fluid info-card text-muted', styles.containerForm)}>
            <HBox flip={window.innerWidth < 768} className={styles.wrapper}>
              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.engine_and_performance')}</h2>
                {['cyllinder_capacity', 'number_of_cillinders', 'acceleration_0_100', 'topspeed', 'torque'].map(type => (
                  <VehicleCreateField key={type} type={type} creditorInfo={this.props.creditorInfo} />
                ))}
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.size_and_weight')}</h2>
                {[
                  'wheelbase',
                  'vehicle_length',
                  'vehicle_width',
                  'vehicle_height',
                  'loadingspace',
                  'tank_contents',
                  'tanks_capacity',
                  'weight_driveready',
                  'empty_weight',
                  'max_allowed_weight',
                  'technical_max_weight_vehicle',
                  'allowed_max_weight_vehicle',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} creditorInfo={this.props.creditorInfo} />
                ))}
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.garantie')}</h2>
                {['warranty_type', 'warranty_period'].map(type => (
                  <VehicleCreateField key={type} type={type} creditorInfo={this.props.creditorInfo} />
                ))}
              </div>
              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.vehicle_info')}</h2>
                {[
                  'number_of_seats',
                  'interior_color',
                  'interior_type',
                  'number_of_doors',
                  'primary_exterior_color_factory_name',
                  'secondary_exterior_color_factory_name',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} />
                ))}
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.technical')}</h2>
                {[
                  'number_of_gears',
                  'number_of_axles',
                  'power_axle',
                  'placecode_as',
                  'trackwidth',
                  'drive_code',
                  'technical_allowed_axle_load',
                  'legally_allowed_axle_load',
                  'vin_number_location',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} />
                ))}
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.pull')}</h2>
                {[
                  'trailer_with_brakes',
                  'trailer_without_brakes',
                  'middleaxle_trailer_with_brakes',
                  'middleaxle_trailer_without_brakes',
                  'autonomous_trailer_with_brakes',
                  'trailercarrier_with_brakes',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} />
                ))}
              </div>
              <div className={styles.containerFlex}>
                <h2 className={styles.title1}>{this.lbl('vehicle.create.columns.finance_and_taxes')}</h2>
                {[
                  'vehicleType',
                  'taxadditions_percentage',
                  'taxaddion_until',
                  'catalogprice_incl_options',
                  'catalogprice_excl_options',
                  'delivery_costs',
                  'intrastat_goods_code',
                  'approvalNumber',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} vehicle_id={this.props.vehicle_id} />
                ))}
                <h2 className={styles.title}>{this.lbl('vehicle.create.columns.consumption_and_environment')}</h2>
                {[
                  'energy_label',
                  'euro_class',
                  'average_consumption_combined',
                  'average_highway_consumption',
                  'average_city_consumption',
                  'consumption_KwH',
                  'max_chargingspeed_DC',
                  'particulate',
                  'is_imported',
                ].map(type => (
                  <VehicleCreateField key={type} type={type} />
                ))}
              </div>
            </HBox>

            <div className="d-flex gap-2 justify-content-end mt-2">
              <ButtonComponent style="ButtonSoftPrimary" onClick={this.prevStep.bind(this)}>
                {this.lbl('previous')}
              </ButtonComponent>

              <ButtonComponent style="ButtonSoftEdit" onClick={this.save.bind(this)}>
                {this.lbl('save')}
              </ButtonComponent>
            </div>
          </div>
        </VBox>
      </Container>
    );
  }
}

VehicleCreateStep5Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(properties, options, callback) {
      dispatch(createVehicleWithProps(properties, options, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateStep5 = compose(withConnect, withRouter)(VehicleCreateStep5Comp);
